module.exports = __webpack_public_path__ + "img/dots-menu.26006e43.svg";